/**
 * Surfaces service worker update lifecycle so the UI can prompt the user
 * to refresh instead of silently swapping content under them.
 */
import { useCallback } from "react";
import { useRegisterSW } from "virtual:pwa-register/react";
import { activateWaitingServiceWorker } from "../shared/activateWaitingServiceWorker.js";

const UPDATE_CHECK_INTERVAL_MS = 60 * 60 * 1000; // 1 hour

export function useAppUpdate() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    offlineReady: [offlineReady, setOfflineReady],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_swUrl, registration) {
      if (!registration) return;
      setInterval(() => {
        registration.update().catch(() => {});
      }, UPDATE_CHECK_INTERVAL_MS);
    },
    onRegisterError(error) {
      console.error("Service worker registration failed:", error);
    },
  });

  const dismiss = useCallback(() => {
    setNeedRefresh(false);
    setOfflineReady(false);
  }, [setNeedRefresh, setOfflineReady]);

  const refresh = useCallback(
    () => activateWaitingServiceWorker(updateServiceWorker),
    [updateServiceWorker]
  );

  return { needRefresh, offlineReady, dismiss, refresh };
}
